import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { INavbarData } from 'src/app/nav-bar/helper';
import { environment } from 'src/environments/environments';
@Component({
  selector: 'rap-profile-nav-bar',
  templateUrl: './profile-nav-bar.component.html',
  styleUrls: ['./profile-nav-bar.component.scss']
})
export class ProfileNavBarComponent {
  screenWidth = 0;
  navData: INavbarData[] = [
    {
      routeLink: '/profile',
      icon: 'bi bi-person',
      label: 'Account Info',
      target: "",
      externalLink: null,
      enabled: true
    }, {
      routeLink: '/change-password',
      icon: 'bi bi-lock',
      label: 'Security',
      target: "",
      externalLink: null,
      enabled: true
    }, {
      routeLink: '',
      icon: 'bi bi-lock',
      label: 'Plan upgrade',
      target: "",
      externalLink: null,
      enabled: true
    }];
  constructor(private router: Router) {

  }

  openStripePortal(event: MouseEvent) {
    event.preventDefault(); // Prevent default anchor navigation
    const portalLink = environment.stripe.portalLink;
    window.open(portalLink, '_blank');
  }

}
